module.exports = __webpack_public_path__ + "static/media/very_fast_game.f23dd466.svg";